module.exports = __webpack_public_path__ + "static/gin-02cf705508e40f97b01e8a351787465b.mp4";